import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Discount_Master_Brands, discountGroupObjects, DISOUNT_MASTER_CHANNEL_OPTIONS } from "./data";
import { GlobalState } from "context/GlobalContext";
import BrandChannel from "./BrandChannel/BrandChannel";
import ApplicableDate from "./ApplicableDateSection/ApplicableDate";
import DiscountValueSection from "./DiscountValueSection/DiscountValueSection";
import { Box, Button, Step, StepLabel, Stepper, Typography } from "@mui/material";
import MasterGeneralInformation from "./MasterGeneralInformation/MasterGeneralInformation";
import ProductSelectionSection from "./ProductSelectionSection/ProductSelectionSection";
import StoreAvailabilitySection from "./StoreAvailabilitySection/StoreAvailabilitySection";
import DiscountOverview from "./DiscountOverview/DiscountOverview";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import { AuthState } from "context/AuthContext";
import FinalSummary from "./summary/summary";
import { useLocation, useNavigate } from "react-router-dom";
import { generateSchemeStr, roleAccess } from "./DiscountMasterList";
import { DialogBox } from "./summary/dialogBox";
import { getStoreDisplayName, getStoreMatchValues, normalizeValue } from "./DiscountSummary";

export function toMySQLDateTime(date) {
  const pad = (n) => n.toString().padStart(2, "0");

  return (
    date.getFullYear() + "-" +
    pad(date.getMonth() + 1) + "-" +
    pad(date.getDate()) + " " +
    pad(date.getHours()) + ":" +
    pad(date.getMinutes()) + ":" +
    pad(date.getSeconds())
  );
}

const jsDate =(date) =>{
	return new Date(date.replace(" ", "T") + "+05:30");
} 

const getInitialState = () => ({
	[discountGroupObjects.brand_channel.key]: {
		store_brand: [],
		channel: "",
	},
	[discountGroupObjects.general_information.key]: {
		scheme_type: "",
		scheme_name: "",
	},
	[discountGroupObjects.applicable_date.key]: {
		start_date: "",
		end_date: "",
		applicable_days: [],
	},
	[discountGroupObjects.store_availability.key]: {
		zone: [],
		distributor: [],
		store: [],
		state: [],
		city: [],
		store_grade: [],
	},
	[discountGroupObjects.discount_value.key]: [],
	[discountGroupObjects.product_selection.key]: {
		discount_table: [],
		discount_barcode_table: [],
	},
});

	const convertApiToState = (data) => {
		const enrichDiscountValue = (discountArray) => {
			return (discountArray || []).map(discount => ({
				...discount,
				display_string: generateSchemeStr([discount], data.scheme_type) || ''
			}));
		};

		return{
		[discountGroupObjects.brand_channel.key]: {
			store_brand: data.brand || [],
			channel: data.channel || "",
		},

		[discountGroupObjects.general_information.key]: {
			scheme_type: data.scheme_type || "",
			scheme_name: data.scheme_name || "",
		},

		[discountGroupObjects.applicable_date.key]: {
			start_date: jsDate(data.start_date) || "",
			end_date: jsDate(data.end_date) || "",
			applicable_days: data.applicable_days || [],
		},

		[discountGroupObjects.store_availability.key]: {
			zone: data.zone || [],
			distributor: data.distributor || [],
			store: data.store || [],
			state: data.state || [],
			city: data.city || [],
			store_grade: data.store_grade || [],
		},

		[discountGroupObjects.discount_value.key]: enrichDiscountValue(data.discounts),

		[discountGroupObjects.product_selection.key]: {
			discount_table: [],
			discount_barcode_table: [],
		},
		}};

function DiscountMaster() {
	const location = useLocation();
	const discountData = location.state?.data;

	const [controlledSteps, setControlledSteps] = useState(0)
	const [value, setValue] = useState(
	discountData === undefined
		? getInitialState()
		: convertApiToState(discountData)
);
	const [storeData, setStoreData] = useState({});
	const [barcodeFile, setBarcodeFile] = useState("");
	const [open, setOpen] = useState(false);
	const [finalSummary, setFinalSummary] = useState([]);
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { user } = AuthState();

	const roleAccessData = roleAccess(user)
	
	const navigate = useNavigate();

	const prevStoreRef = useRef(value[discountGroupObjects.store_availability.key]);
	const prevBrandChannelRef = useRef(value[discountGroupObjects.brand_channel.key]);

	const stpesNames = [discountGroupObjects.brand_channel.key,
		discountGroupObjects.store_availability.key,
		discountGroupObjects.product_selection.key,
	discountGroupObjects.applicable_date.key,
	discountGroupObjects.general_information.key,
discountGroupObjects.discount_value.key]

const cascadeOrder = [
	"distributor",
	"zone",
	"state",
	"city",
	"store_grade",
	"store",
];

	const getStores = async () => {
			try {
				// setDownloading(true);
				setLoadingOpen(true);
				await pythonVmInstance({
					url: `/discount-master/get`,
					headers: {
						"Content-Type": "application/json",
					},
					method: "GET",
				}).then((res) => {
					setStoreData(res?.data);
					discountData === undefined && setLoadingOpen(false);
				});
			} catch (error) {
				setSnackBarOpen(true);
				setLoadingOpen(false);
				setSnackBar({
					...snackBar,
					message: "Failed to download file",
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			}
		};
	const getBarcodes = async () => {
			try {
				setLoadingOpen(true);
				const res = await pythonVmInstance({
					url: `/discount-master/get-barcodes`,
					params: { 
						channel: value?.[discountGroupObjects.brand_channel.key]?.channel, 
						barcode_url: discountData !== undefined ? discountData["barcode_file_url"] : null, 
						discounted_ean_url: discountData !== undefined ? discountData["summary_file_url"] : null 
					},
					headers: {
						"Content-Type": "application/json",
					},
					method: "GET",
				});
				
				setValue((prev) => ({
					...prev,
					[discountGroupObjects.product_selection.key]: {
						discount_table: res?.data?.["item_details"] || [],
						discount_barcode_table: res?.data?.["barcode_details"] || []
					}
				}));
				
				if (discountData?.final_summary) {
					setFinalSummary(discountData.final_summary);
				}
				
				setLoadingOpen(false);
			} catch (error) {
				console.log("error", error)
				setSnackBarOpen(true);
				setLoadingOpen(false);
				setSnackBar({
					...snackBar,
					message: "Failed to download file",
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			}
		};
	

	const isFilled = (data) => {
	if (data === null || data === undefined) return false;

	// ✅ Array validation
	if (Array.isArray(data)) {
		if (data.length === 0) return false;

		return data.every((item) => isFilled(item));
	}

	// ✅ Object validation
	if (typeof data === "object") {
		return Object.values(data).every((val) => isFilled(val));
	}

	// ✅ Primitive validation
	return data !== "";
};

const handleStepperChange = () => {
	let countSteps = 0;
	
	for (let i = 0; i < stpesNames.length; i++) {
		const key = stpesNames[i];
		let stepValue = value[key];
		
		if (value[discountGroupObjects.brand_channel.key].channel !== "MBO") {
			delete stepValue?.distributor
		}
		
		if (key === discountGroupObjects.product_selection.key) {
			const hasProducts = stepValue?.discount_table?.length > 0;
			if (!hasProducts) {
				countSteps = i;
				break;
			}
		} else {
			const allFilled = isFilled(stepValue);
			if (!allFilled) {
				countSteps = i;
				break;
			}
		}

		countSteps = i + 1;
	}

	setControlledSteps(countSteps);
};

 const handleDropDownMissBeheviour = () =>{
		const currentBrand = value[discountGroupObjects.brand_channel.key];
		const currentStore = value[discountGroupObjects.store_availability.key];
		const prevBrand = prevBrandChannelRef.current;
		const prevStore = prevStoreRef.current;

		const isBrandChanged = JSON.stringify(prevBrand.store_brand || []) !== JSON.stringify(currentBrand.store_brand || []);
		const isChannelChanged = (prevBrand.channel || "") !== (currentBrand.channel || "");

		if (isBrandChanged || isChannelChanged) {
			setValue((prev) => ({
				...prev,
				[discountGroupObjects.store_availability.key]: {
					...getInitialState()[discountGroupObjects.store_availability.key]
				}
			}));
			prevBrandChannelRef.current = JSON.parse(JSON.stringify(currentBrand));
			prevStoreRef.current = {
				...getInitialState()[discountGroupObjects.store_availability.key],
			};
			return;
		}

		let changedKey = null;
		for (const key of cascadeOrder) {
			if (JSON.stringify(prevStore[key]) !== JSON.stringify(currentStore[key])) {
				changedKey = key;
				break;
			}
		}

		if (changedKey) {
			const index = cascadeOrder.indexOf(changedKey);
			const updatedStore = { ...currentStore };
			for (let i = index + 1; i < cascadeOrder.length; i++) {
				updatedStore[cascadeOrder[i]] = [];
			}
			setValue((prev) => ({
				...prev,
				[discountGroupObjects.store_availability.key]: updatedStore
			}));
		}

		prevStoreRef.current = JSON.parse(JSON.stringify(currentStore));
		prevBrandChannelRef.current = JSON.parse(JSON.stringify(currentBrand));
 }

	useEffect(() => {
		if (Object.keys(storeData).length > 0 && discountData === undefined) {
			handleDropDownMissBeheviour();
		}
	}, [JSON.stringify(value[discountGroupObjects.brand_channel.key]?.store_brand), value[discountGroupObjects.brand_channel.key]?.channel, JSON.stringify(value[discountGroupObjects.store_availability.key])]);

	useEffect(() => {
		handleStepperChange();

		if (value[discountGroupObjects.discount_value.key].length === 0) {
			setFinalSummary([]);
		} else if (value[discountGroupObjects.product_selection.key]?.discount_barcode_table?.length > 0) {
			handleFinalSummary();
		}
	}, [value]);


	useEffect(() => {
		const loadData = async () => {
			await getStores();
			if (discountData !== undefined) {
				await getBarcodes();
			}
		};
		loadData();
		return () => {
			setValue(getInitialState());
			setFinalSummary([]);
			setBarcodeFile("");
		};
	}, []);
	useEffect(() => {
	if (!discountData) {
		setValue(getInitialState());
		setFinalSummary([]);
		setBarcodeFile("");
	}
}, [location.pathname]);

	const create_api_request = (form) =>{
		pythonVmInstance
				.post("/discount-master/create", form, { headers: { "Content-Type": "multipart/form-data" } })
				.then((res) => {
					setLoadingOpen(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "Uploaded the files successfully",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
					navigate(-1)
				})
				.catch((err) => {
					console.log("uploaded", err);
					const message = err?.response?.data?.message;
					setLoadingOpen(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: message ? message : "Unable to uploaded the files",
						severity: "error",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				});
	}
	const update_api_request = (form) =>{
		form.append("id", discountData?.id);
		pythonVmInstance
				.put(`/discount-master/create`, form, { headers: { "Content-Type": "multipart/form-data" } })
				.then((res) => {
					setLoadingOpen(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "Uploaded the files successfully",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
					navigate(-1)
				})
				.catch((err) => {
					console.log("uploaded", err);
					const message = err?.response?.data?.message;
					setLoadingOpen(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: message ? message : "Unable to uploaded the files",
						severity: "error",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				});
	}

	const handleGetStoreData = async (channel, brand) => {
				try {
					setLoadingOpen(true);
					const params = new URLSearchParams({
									channel: channel,
									brand: brand,
								});
								const res = await pythonVmInstance.get(`/discount-master/discount-store-master?${params.toString()}`);
	
					return res?.data;
				} catch (err) {
					throw new Error("Failed to fetch store data");
				}
			};

	const handleCheckStoreEmails = async (channel,brand,selectedStore = []) => {

	let stores = await handleGetStoreData(channel, brand);

	let missingEmail = [];

	const normalizedSelectedStores = selectedStore.map(normalizeValue);

	stores.forEach((store) => {

		// Match selected store
		const isSelectedStore = getStoreMatchValues(store).some((value) =>
			normalizedSelectedStores.includes(value)
		);

		if (!isSelectedStore) return;

		// Get all email related fields
		const emailFields = Object.keys(store).filter((key) => {
			const normalizedKey = key.toLowerCase();

			return (
				normalizedKey.includes("_email") ||
				normalizedKey.includes("email") ||
				normalizedKey.includes("mail")
			);
		});

		// Extract values
		const emailValues = emailFields
			.map((field) => store[field])
			.filter(Boolean);

		// Check if atleast one valid email exists
		const hasValidEmail = emailValues.some((email) => {

			if (Array.isArray(email)) {
				return email.some(
					(e) =>
						typeof e === "string" &&
						e.includes("@")
				);
			}

			return (
				typeof email === "string" &&
				email.includes("@")
			);
		});

		// No valid email found
		if (!hasValidEmail) {
			missingEmail.push(getStoreDisplayName(store));
		}
	});

	return missingEmail;
};

	const handleSave = async (from) => {
			// e.preventDefault();
			setLoadingOpen(true);

			const channel = value[discountGroupObjects.brand_channel.key]?.channel || '';
			const brand = value[discountGroupObjects.brand_channel.key]?.store_brand || [];
			const stores = value[discountGroupObjects.store_availability.key]?.store || [];

			const missingEmail = from === "submit" && await handleCheckStoreEmails(channel, brand, stores); 

			if (from === "submit" && missingEmail.length > 0) {
				setSnackBarOpen(true);

				setSnackBar({
					...snackBar,
					message: `Stores are missing email addresses: ${missingEmail.join(
						", "
					)}, please update the store master data before publishing.`,
					severity: "warning",
					anchorOrigin: {
						horizontal: "center",
						vertical: "top",
					},
				});

				setLoadingOpen(false);
				return;
			}
			let form = new FormData();
			if (value[discountGroupObjects.product_selection.key].discount_table?.length === 0) {
				// setLoadingOpen(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Please upload some files and try again",
					severity: "warning",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
				return;
			}
			let discount_details = {}

			discount_details["brand"] = value[discountGroupObjects.brand_channel.key]?.store_brand || []
			discount_details["channel"] = value[discountGroupObjects.brand_channel.key]?.channel || ''
			discount_details["scheme_type"] = value[discountGroupObjects.general_information.key]?.scheme_type || ''
			discount_details["scheme_name"] = value[discountGroupObjects.general_information.key]?.scheme_name || ''
			discount_details["start_date"] = toMySQLDateTime(value[discountGroupObjects.applicable_date.key]?.start_date) || ''
			discount_details["end_date"] = toMySQLDateTime(value[discountGroupObjects.applicable_date.key]?.end_date) || ''
			discount_details["applicable_days"] = value[discountGroupObjects.applicable_date.key]?.applicable_days || []
			// const enrichedDiscountValue = (value[discountGroupObjects.discount_value.key] || []).map(discount => ({
			// 	...discount,
			// 	display_string: generateSchemeStr([discount], value[discountGroupObjects.general_information.key]?.scheme_type) || ''
			// }));

			const enrichedDiscountValue = (
				value[discountGroupObjects.discount_value.key] || []
			).map((discount) => {

				const {
					updated_at,
					created_at,
					...restDiscount
				} = discount;

				return {
					...restDiscount,

					display_string:
						generateSchemeStr(
							[restDiscount],
							value[
								discountGroupObjects
									.general_information.key
							]?.scheme_type
						) || "",
				};
			});

			discount_details["discount_value"] = enrichedDiscountValue;
			// discount_details["discount_table"] = value[discountGroupObjects.product_selection.key]?.discount_table || [];
			// discount_details["discount_barcode_table"] = value[discountGroupObjects.product_selection.key]?.discount_barcode_table || [];
			discount_details["city"] = value[discountGroupObjects.store_availability.key]?.city || []
			discount_details["state"] = value[discountGroupObjects.store_availability.key]?.state || []
			discount_details["zone"] = value[discountGroupObjects.store_availability.key]?.zone || []
			discount_details["distributor"] = value[discountGroupObjects.store_availability.key]?.distributor || []
			discount_details["store_grade"] = value[discountGroupObjects.store_availability.key]?.store_grade || []
			discount_details["store"] = value[discountGroupObjects.store_availability.key]?.store || []
			discount_details["submitted_by"] = from === "submit" ? user?.email : null
			discount_details["submitted_at"] = from === "submit" ? toMySQLDateTime(new Date()) : null
			discount_details["created_by"] = user?.email || null
			discount_details["updated_by"] = user?.email || null
			// discount_details["discount_str"] = finalSummary[0]?.scheme
			discount_details["updated_at"] = toMySQLDateTime(new Date())
			discount_details["status"] = from === "submit" ? "Submitted" : "Draft"
			discount_details["barcode_file_url"] = discountData !== undefined ? discountData["barcode_file_url"] : null
			discount_details["summary_file_url"] = discountData !== undefined ? discountData["summary_file_url"] : null
			discount_details["final_summary"] = finalSummary || []
			
			console.log("djbjdbvjbwufvbuadvdac", discount_details["discount_value"])

			form.append("files", barcodeFile);
			form.append("discount_details", JSON.stringify(discount_details));
			form.append("from", from);
			
			if (discountData !== undefined) {
				update_api_request(form)
			}
			else{
				create_api_request(form)
			}

		};

	const handleFileUpload = async (e) => {
			e.preventDefault();
			setLoadingOpen(true);
			let form = new FormData();
			if (barcodeFile === "") {
				// setLoadingOpen(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Please upload some files and try again",
					severity: "warning",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
				return;
			}
	
			form.append("files", barcodeFile);
			form.append("email", user.email);
			form.append("channel", value?.[discountGroupObjects.brand_channel.key]?.channel);
			pythonVmInstance
				.post("/discount-master/upload-barcodes", form, { headers: { "Content-Type": "multipart/form-data" } })
				.then((res) => {
					setLoadingOpen(false);
					
					const itemDetails = res?.data?.item_details || [];
					const barcode_details = res?.data?.barcode_details || [];
					
					setValue({
						...value,
						[discountGroupObjects.product_selection.key]: {
							...value[discountGroupObjects.product_selection.key],
							discount_table: itemDetails,
							discount_barcode_table: barcode_details
						}
						});

					// Selected brands
					const selectedBrands =
						value?.[discountGroupObjects.brand_channel.key]?.store_brand || [];

					// Exclude THOR and GUILD
					const allowedBrands = selectedBrands.filter(
						(brand) => !["THOR", "GUILD"].includes(brand?.toUpperCase())
					);

					// Uploaded brands from API response
					const uploadedBrands = [
						...new Set(
							itemDetails
								.map((item) => item?.brand?.trim()?.toUpperCase())
								.filter(Boolean)
						),
					];

					// Find unmatched brands
					const invalidBrands = uploadedBrands.filter(
						(brand) => !allowedBrands.map((b) => b?.toUpperCase()).includes(brand)
					);

					if (invalidBrands.length > 0) {
						setSnackBarOpen(true);
						setSnackBar({
							...snackBar,
							message: `Warning: Uploaded file contains invalid brands: ${invalidBrands.join(", ")}`,
							severity: "warning",
							anchorOrigin: { horizontal: "center", vertical: "top" },
						});

						return;
					}
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "Uploaded the files successfully",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
					
				})
				.catch((err) => {
					console.log("uploaded", err);
					const message = err?.response?.data?.message;
					setLoadingOpen(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: message ? message : "Unable to uploaded the files",
						severity: "error",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				});
		};
	
	const handleFinalSummary = () => {
		const previousSummaryById = new Map(
			(finalSummary || []).map((row, index) => {
				const rowId = row?.BARCODE || row?.barcode || row?.Barcode || row?.bar_code || row?.EAN || row?.ean || row?.sku || row?.SKU || row?.id || `${row?.category || "row"}-${row?.option || index}-${index}`;
				return [rowId, row];
			})
		);
		const discounts = value[discountGroupObjects.discount_value.key] || [];
		const firstDiscountArray = discounts.slice(0, 1);
		const initialScheme = generateSchemeStr(firstDiscountArray, value[discountGroupObjects.general_information.key]?.scheme_type) || '';
		const initialId = firstDiscountArray[0]?.id ? [firstDiscountArray[0].id] : [];

		const enrichDiscountValue = (discountArray) => {
			return discountArray.map(discount => ({
				...discount,
				display_string: generateSchemeStr([discount], value[discountGroupObjects.general_information.key]?.scheme_type) || ''
			}));
		};

		let data = value[discountGroupObjects.product_selection.key]?.discount_barcode_table.map(element => {
			const rowId = element?.BARCODE || element?.barcode || element?.Barcode || element?.bar_code || element?.EAN || element?.ean || element?.sku || element?.SKU || element?.id || `${element?.category || "row"}-${element?.option || ''}`;
			const previousRow = previousSummaryById.get(rowId);
			return {...element,
				// 'scheme': previousRow?.scheme || initialScheme,
				'discount_value_id': previousRow?.discount_value_id || initialId,
				'discount_value': previousRow?.discount_value ? enrichDiscountValue(previousRow.discount_value) : enrichDiscountValue(firstDiscountArray),
				'scheme_name': value[discountGroupObjects.general_information.key]?.scheme_name || '',
				'date': `${value[discountGroupObjects.applicable_date.key]?.start_date || ''} to ${value[discountGroupObjects.applicable_date.key]?.end_date || ''}`,
				'days': value[discountGroupObjects.applicable_date.key]?.applicable_days || [],
			}
		});
		setFinalSummary(data);
	};

	let itemBrandOptions = Discount_Master_Brands.filter(brands => roleAccessData?.brandList.includes(brands?.key))?.map((b) => {
		return { name: b?.key, key: b?.key };
	});

	let channelOptions =DISOUNT_MASTER_CHANNEL_OPTIONS?.filter(channel => roleAccessData?.channelList.includes(channel["name"]));

	let allChannels = [
	...(storeData?.ebo_stores || []),
	...(storeData?.lfs_stores || []),
	...(storeData?.mbo_stores || [])
	].flat();



	let storeDetails = allChannels?.filter((store) => {
	const selectedBrands =
		value?.[discountGroupObjects.brand_channel.key]?.store_brand || [];

	const selectedChannel =
		value?.[discountGroupObjects.brand_channel.key]?.channel;
	return (
		(store?.channel || "").trim() === (selectedChannel || "").trim() &&
		selectedBrands.includes((store?.brand || "").trim())
	);
});

	console.log("sdbcjabsdjbajsdc", value)
	return (
		<Box width="100%" pt={4}>
			<Box display="flex" flexDirection={"row"} width={"100%"} justifyContent={"space-between"}>
				<Box width={"65%"}>
					<Stepper orientation="vertical" nonLinear activeStep={controlledSteps}>
						<Step expanded completed={controlledSteps > 0}>
							<StepLabel>Brand and Channel Selection</StepLabel>
							<Box mt={2} mb={4}width={"90%"}>
								<BrandChannel value={value} setValue={setValue} disable={controlledSteps < 0} data={{"store_brand": itemBrandOptions, "channel":channelOptions }} />
							</Box>
						</Step>
						<Step expanded completed={controlledSteps > 1}>
							<StepLabel>Store Availability</StepLabel>
							<Box mt={2} mb={4} width={"90%"}>
								<StoreAvailabilitySection value={value} setValue={setValue} disable={controlledSteps < 1 } data = {storeDetails} />
							</Box>
						</Step>
						<Step expanded completed={controlledSteps > 2}>
							<StepLabel>Product Selection</StepLabel>
							<Box mt={2} mb={4} width={"90%"}>
								<ProductSelectionSection value={value} setValue={setValue} disable={controlledSteps < 2} onBlurEvent = {getStores} barcodeFile={barcodeFile} setBarcodeFile={setBarcodeFile} handleFileUpload = {handleFileUpload} table_data = {value?.[discountGroupObjects.product_selection.key]?.discount_table} />
							</Box>
						</Step>

						<Step expanded completed={controlledSteps > 3}>
							<StepLabel>Applicable Date</StepLabel>
							<Box mt={2} mb={4} width={"90%"}>
								<ApplicableDate value={value} setValue={setValue} disable={controlledSteps < 3} />
							</Box>
						</Step>
						<Step expanded completed={controlledSteps > 4}>
							<StepLabel>General Information</StepLabel>
							<Box mt={2} mb={4}>
								<MasterGeneralInformation value={value} setValue={setValue} disable={controlledSteps < 4} />
							</Box>
						</Step>
						<Step expanded completed={controlledSteps > 5}>
							<StepLabel>Discount Value</StepLabel>
							<Box mt={1} mb={4} width={"100%"}>
								<DiscountValueSection value={value} setValue={setValue}  disable={controlledSteps < 5} handleFinalSummary = {handleFinalSummary} setFinalSummary={setFinalSummary} storeDetails={storeDetails} />
							</Box>
						</Step>
					</Stepper>
				</Box>
				{/* <Box width={"52%"} display={"flex"} position={"sticky"} right={0} top={80} flexDirection={"column"} alignItems={"center"} rowGap={2}
				sx={{
						height: "calc(100vh - 100px)", // limit height relative to viewport
						overflowY: "auto",            // enable scroll inside
						// paddingRight: 2,              // optional scrollbar spacing
					}}
				>
					<DiscountOverview />
				</Box> */}
			</Box>
			{finalSummary.length > 0 && <Box>
				<FinalSummary
					discount_details={value}
					data={finalSummary}
					setData={setFinalSummary}
					discountValues={value[discountGroupObjects.discount_value.key] || []}
					schemeTypes={value[discountGroupObjects.general_information.key]?.scheme_type}
				/>
			</Box>}
			<Box mt={4} display="flex" justifyContent="flex-end" columnGap={2}>
				<Button variant="contained" onClick={() => handleSave( "save")} disabled={finalSummary.length === 0 || controlledSteps < 5}>
					Save
				</Button>
				<Button variant="contained" onClick={setOpen} disabled={finalSummary.length === 0 || controlledSteps < 5}>
					Submit
				</Button>
			</Box>
			<DialogBox open={open} setOpen={setOpen} body={"This action is irreversible. Do you want to proceed? An approval request will be sent via email."} handleOK={() => handleSave("submit")} />
		</Box>
	);
}

export default DiscountMaster;
